export class AccountHelper {
    private static _instance: AccountHelper;

    token : any;

    staff: boolean = false;
    staffAdmin: boolean = false;
    ngRodeoAdmin: boolean = false;

    incognito: boolean = false;

    private constructor() { }

    static instance() : AccountHelper {
        if (this._instance == undefined)
            this._instance = new this();

        return this._instance;
    }

    loadToken(token) {
        this.token = token;
        
        if (this.token != null && this.token.roles != null) {
            this.staff = this.token.roles.filter(x => x.roleId >= 2).length > 0;
            this.staffAdmin = this.token.roles.filter(x => x.roleId >= 5).length > 0;
            this.ngRodeoAdmin = this.token.roles.filter(x => x.roleId >= 6).length > 0;
        }
    }

    toggleMode() {
        this.incognito = !this.incognito;
    }

    clearToken() {
        this.token = undefined;
        this.staff = false;
        this.staffAdmin = false;
        this.ngRodeoAdmin = false;
    }

    isStaff(superman:boolean = false) {
        if (!superman && this.incognito)
            return false;

        return this.staff;
    }

    isStaffOfEvent(event) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == event.organization.id && x.producerId == event.producer.id && x.roleId > 1).length > 0;
    }  

    isStaffAdminOfEvent(event) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == event.organization.id && x.producerId == event.producer.id && x.roleId >= 5).length > 0;
    }

    isStaffSecretaryOfEvent(event) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == event.organization.id && x.producerId == event.producer.id && x.roleId >= 4).length > 0;
    }  

    isStaffBasicSecretaryOfEvent(event) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == event.organization.id && x.producerId == event.producer.id && x.roleId >= 3).length > 0;
    }  
    
    isStaffOfOrganization(organization) {
        if (this.incognito || this.token == undefined || this.token.roles == undefined)
            return false;

        if (this.ngRodeoAdmin)
            return true;

        return this.token.roles.filter(x => x.organizationId == organization.id && x.roleId > 1).length > 0;
    }

    isStaffAdmin() {
        if (this.incognito)
            return false;

        return this.staffAdmin;
    }

    isNextGenAdmin() {
        if (this.incognito)
            return false;

        return this.ngRodeoAdmin;
    }

    getAccountId() {
        return this.token.id;
    }
}


// WEBPACK FOOTER //
// ./src/lib/accountHelper.ts